// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateOrganizationBindingAdmin, UpdateOrganizationBindingAdminSchema } from 'api/gen/UpdateOrganizationBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOrganizationBindingAdminBaseObject, ValidateOrganizationBindingAdminBaseObjectSchema } from 'api/gen/ValidateOrganizationBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateOrganizationBindingAdmin'),
  binding: t.union([UpdateOrganizationBindingAdminSchema, t.null]),
});

export const ValidateUpdateOrganizationBindingAdminSchema = excess(t.intersection([ValidateOrganizationBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateOrganizationBindingAdmin extends t.TypeOf<typeof ValidateUpdateOrganizationBindingAdminSchema> {}
